import { defineComponent } from 'vue';

import {
  getChartThemeColors,
  getEchartsTheme,
  IChartThemeColors,
  IEchartsTheme,
} from '@/bundles/Visualizations/helpers/echartsTheme';

// ECharts 5 takes a theme only in `init()`, so a chart built at mount would keep
// the theme it started with. Charts init with `echartsTheme` and watch it to
// rebuild their instance when the theme changes (profile menu > Theme).
export const EchartsThemeMixin = defineComponent({
  computed: {
    chartColors (): IChartThemeColors {
      return getChartThemeColors(this.$vuetify.theme.current.colors);
    },

    echartsTheme (): IEchartsTheme {
      return getEchartsTheme(this.chartColors, this.$vuetify.theme.current.dark);
    },
  },
});
